import axios from "axios";
import { aiRequestUrl } from "../config/config";

const data = {
  role: "user",
  parts: [
    {
      text: "Hi",
    },
  ],
};

export const makeRequest = async (aiPrompt: string) => {
  try {
    data.parts[0].text = aiPrompt;
    const response = await axios.post(aiRequestUrl, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    const responseText = response.data.candidates[0].content.parts[0].text;
    console.log(responseText);
    return responseText;
  } catch (error) {
    console.error("Error making request:", error);
    return error;
  }
};
